<template>
  <section class="form-statistics">
    <FormData
      :forms="statisticsArray"
      v-if="statisticsFetched"
      @updatedFormList="fetchAndSortFormStatistics"
    />
    <fetching-loader
      class="form-statistics__spinner"
      displayType="displayBlock"
      v-else
    ></fetching-loader>
  </section>
</template>

<script>
import { firestore } from "@/firebase";
import FetchingLoader from "@/components/GlobalComponents/FetchingLoader";
import FormData from "./FormData";

export default {
  name: "form-statistics",
  components: {
    FormData,
    FetchingLoader,
  },
  data() {
    return {
      statisticsArray: [],
      statisticsFetched: false,
    };
  },
  methods: {
    fetchAndSortFormStatistics() {
      const formArray = [];
      this.statisticsArray = [];
      this.statisticsFetched = false;
      firestore
        .collection("FormStatistics")
        .doc(`${this.$hotelId}`)
        .collection("Forms")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            let form = doc.data();
            formArray.push({ ...form, formID: doc.id });
          });

          const deleted =
            formArray
              .filter((el) => el.visibility == "deleted")
              .sort((a, b) => b.totalRevenue - a.totalRevenue) || [];
          const hidden =
            formArray
              .filter((el) => el.visibility.length == 0)
              .sort((a, b) => b.totalRevenue - a.totalRevenue) || [];
          const rest =
            formArray
              .filter(
                (el) => el.visibility.length != 0 && el.visibility != "deleted"
              )
              .sort((a, b) => b.totalRevenue - a.totalRevenue) || [];

          this.statisticsArray.push(...rest);
          this.statisticsArray.push(...hidden);
          this.statisticsArray.push(...deleted);
          this.statisticsFetched = true;
        });
    },
  },
  created() {
    this.fetchAndSortFormStatistics();
  },
};
</script>

<style scoped>
.form-statistics {
  height: 100%;
  width: 100%;
}

.form-statistics__spinner {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
